/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Trust_PermissionsInputs */

const es_home_hero_trust_permissions = /** @type {(inputs: Home_Hero_Trust_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos por usuario`)
};

const en_home_hero_trust_permissions = /** @type {(inputs: Home_Hero_Trust_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per-user permissions`)
};

/**
* | output |
* | --- |
* | "Per-user permissions" |
*
* @param {Home_Hero_Trust_PermissionsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_trust_permissions = /** @type {((inputs?: Home_Hero_Trust_PermissionsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Trust_PermissionsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_trust_permissions(inputs)
	return en_home_hero_trust_permissions(inputs)
});
export { home_hero_trust_permissions as "home.hero.trust_permissions" }